<div>
  <b i18n="@@termsAndConditions">Terms and Conditions</b>
  <p i18n="@@lastUpdated">Last updated: December 05, 2017</p>
  <p i18n="@@termsIntro">
    These Terms and Conditions ("Terms", "Terms and Conditions") govern your
    relationship with www.S2CRIPT.com website and S2CRIPT mobile application
    (the "Service") operated by S2CRIPT BV ("us", "we", or "our").
  </p>
  <p i18n="@@termsReadCarefully">
    Please read these Terms and Conditions carefully before using our website
    and S2CRIPT mobile application (the "Service").
  </p>
  <p i18n="@@termsAcceptance">
    Your access to and use of the Service is conditioned on your acceptance of
    and compliance with these Terms. These Terms apply to all visitors, users
    and others who access or use the Service.
  </p>
  <p i18n="@@termsAgree">
    By accessing or using the Service you agree to be bound by these Terms. If
    you disagree with any part of the terms then you may not access the Service.
  </p>

  <b i18n="@@subscriptions">Subscriptions</b>
  <p i18n="@@subscriptionsBilling">
    Some parts of the Service are billed on a subscription basis
    ("Subscription(s)"). You will be billed in advance on a recurring and
    periodic basis ("Billing Cycle"). Billing cycles are set on a annual basis.
  </p>
  <p i18n="@@subscriptionsAutoRenew">
    At the end of each Billing Cycle, your Subscription will automatically renew
    under the exact same conditions unless you cancel it or S2CRIPT BV cancels
    it. You may cancel your Subscription renewal either through your online
    account management page or by contacting S2CRIPT BV customer support team.
  </p>
  <p i18n="@@subscriptionsPaymentMethod">
    A valid payment method, including credit card or PayPal, is required to
    process the payment for your Subscription. You shall provide S2CRIPT BV with
    accurate and complete billing information including full name, address,
    state, zip code, telephone number, and a valid payment method information.
    By submitting such payment information, you automatically authorize S2CRIPT
    BV to charge all Subscription fees incurred through your account to any such
    payment instruments.
  </p>
  <p i18n="@@subscriptionsFailedBilling">
    Should automatic billing fail to occur for any reason, S2CRIPT BV will issue
    an electronic invoice indicating that you must proceed manually, within a
    certain deadline date, with the full payment corresponding to the billing
    period as indicated on the invoice.
  </p>

  <b i18n="@@freeTrial">Free Trial</b>
  <p i18n="@@freeTrialOffer">
    S2CRIPT BV may, at its sole discretion, offer a Subscription with a free
    trial for a limited period of time ("Free Trial").
  </p>
  <p i18n="@@freeTrialBillingInfo">
    You may be required to enter your billing information in order to sign up
    for the Free Trial.
  </p>
  <p i18n="@@freeTrialCharges">
    If you do enter your billing information when signing up for the Free Trial,
    you will not be charged by S2CRIPT BV until the Free Trial has expired. On
    the last day of the Free Trial period, unless you cancelled your
    Subscription, you will be automatically charged the applicable Subscription
    fees for the type of Subscription you have selected.
  </p>
  <p i18n="@@freeTrialChanges">
    At any time and without notice, S2CRIPT BV reserves the right to (i) modify
    the terms and conditions of the Free Trial offer, or (ii) cancel such Free
    Trial offer.
  </p>

  <b i18n="@@feeChanges">Fee Changes</b>
  <p i18n="@@feeChangesModify">
    S2CRIPT BV, in its sole discretion and at any time, may modify the
    Subscription fees for the Subscriptions. Any Subscription fee change will
    become effective at the end of the then-current Billing Cycle.
  </p>
  <p i18n="@@feeChangesNotice">
    S2CRIPT BV will provide you with a reasonable prior notice of any change in
    Subscription fees to give you an opportunity to terminate your Subscription
    before such change becomes effective.
  </p>
  <p i18n="@@feeChangesAgreement">
    Your continued use of the Service after the Subscription fee change comes
    into effect constitutes your agreement to pay the modified Subscription fee
    amount.
  </p>

  <b i18n="@@refunds">Refunds</b>
  <p i18n="@@refundsPolicy">
    Except when required by law, paid Subscription fees are nonrefundable.
  </p>

  <b i18n="@@content">Content</b>
  <p i18n="@@contentResponsibility">
    Our Service allows you to post, link, store, share and otherwise make
    available certain information, text, graphics, videos, or other material
    ("Content"). You are responsible for the Content that you post to the
    Service, including its legality, reliability, and appropriateness.
  </p>
  <p i18n="@@contentLicense">
    By posting Content to the Service, you grant us the right and license to
    use, modify, publicly perform, publicly display, reproduce, and distribute
    such Content on and through the Service. You retain any and all of your
    rights to any Content you submit, post or display on or through the Service
    and you are responsible for protecting those rights. You agree that this
    license includes the right for us to make your Content available to other
    users of the Service, who may also use your Content subject to these Terms.
  </p>
  <p i18n="@@contentWarranties">
    You represent and warrant that: (i) the Content is yours (you own it) or you
    have the right to use it and grant us the rights and license as provided in
    these Terms, and (ii) the posting of your Content on or through the Service
    does not violate the privacy rights, publicity rights, copyrights, contract
    rights or any other rights of any person.
  </p>

  <b i18n="@@accounts">Accounts</b>
  <p i18n="@@accountsAccuracy">
    When you create an account with us, you must provide us information that is
    accurate, complete, and current at all times. Failure to do so constitutes a
    breach of the Terms, which may result in immediate termination of your
    account on our Service.
  </p>
  <p i18n="@@accountsPassword">
    You are responsible for safeguarding the password that you use to access the
    Service and for any activities or actions under your password, whether your
    password is with our Service or a third-party service.
  </p>
  <p i18n="@@accountsNotShare">
    You agree not to disclose your password to any third party. You must notify
    us immediately upon becoming aware of any breach of security or unauthorized
    use of your account.
  </p>
  <p i18n="@@accountsUsername">
    You may not use as a username the name of another person or entity or that
    is not lawfully available for use, a name or trade mark that is subject to
    any rights of another person or entity other than you without appropriate
    authorization, or a name that is otherwise offensive, vulgar or obscene.
  </p>

  <b i18n="@@intellectualProperty">Intellectual Property</b>
  <p i18n="@@intellectualPropertyText">
    The Service and its original content (excluding Content provided by users),
    features and functionality are and will remain the exclusive property of
    S2CRIPT BV and its licensors. The Service is protected by copyright,
    trademark, and other laws of both the Netherlands and foreign countries. Our
    trademarks and trade dress may not be used in connection with any product or
    service without the prior written consent of S2CRIPT BV.
  </p>

  <b i18n="@@linksToOtherWebsites">Links To Other Web Sites</b>
  <p i18n="@@linksResponsibility">
    Our Service may contain links to third-party web sites or services that are
    not owned or controlled by S2CRIPT BV.
  </p>
  <p i18n="@@linksDisclaimer">
    S2CRIPT BV has no control over, and assumes no responsibility for, the
    content, privacy policies, or practices of any third party web sites or
    services. You further acknowledge and agree that S2CRIPT BV shall not be
    responsible or liable, directly or indirectly, for any damage or loss caused
    or alleged to be caused by or in connection with use of or reliance on any
    such content, goods or services available on or through any such web sites
    or services.
  </p>
  <p i18n="@@linksAdvice">
    We strongly advise you to read the terms and conditions and privacy policies
    of any third-party web sites or services that you visit.
  </p>

  <b i18n="@@termination">Termination</b>
  <p i18n="@@terminationPolicy">
    We may terminate or suspend your account immediately, without prior notice
    or liability, for any reason whatsoever, including without limitation if you
    breach the Terms.
  </p>
  <p i18n="@@terminationEffect">
    Upon termination, your right to use the Service will immediately cease. If
    you wish to terminate your account, you may simply discontinue using the
    Service.
  </p>

  <b i18n="@@limitationOfLiability">Limitation Of Liability</b>
  <p i18n="@@liabilityText">
    In no event shall S2CRIPT BV, nor its directors, employees, partners,
    agents, suppliers, or affiliates, be liable for any indirect, incidental,
    special, consequential or punitive damages, including without limitation,
    loss of profits, data, use, goodwill, or other intangible losses, resulting
    from (i) your access to or use of or inability to access or use the Service;
    (ii) any conduct or content of any third party on the Service; (iii) any
    content obtained from the Service; and (iv) unauthorized access, use or
    alteration of your transmissions or content, whether based on warranty,
    contract, tort (including negligence) or any other legal theory, whether or
    not we have been informed of the possibility of such damage, and even if a
    remedy set forth herein is found to have failed of its essential purpose.
  </p>

  <b i18n="@@disclaimer">Disclaimer</b>
  <p i18n="@@disclaimerText">
    Your use of the Service is at your sole risk. The Service is provided on an
    "AS IS" and "AS AVAILABLE" basis. The Service is provided without warranties
    of any kind, whether express or implied, including, but not limited to,
    implied warranties of merchantability, fitness for a particular purpose,
    non-infringement or course of performance.
  </p>
  <p i18n="@@disclaimerWarranties">
    S2CRIPT BV its subsidiaries, affiliates, and its licensors do not warrant
    that a) the Service will function uninterrupted, secure or available at any
    particular time or location; b) any errors or defects will be corrected; c)
    the Service is free of viruses or other harmful components; or d) the
    results of using the Service will meet your requirements.
  </p>

  <b i18n="@@governingLaw">Governing Law</b>
  <p i18n="@@governingLawText">
    These Terms shall be governed and construed in accordance with the laws of
    Netherlands, without regard to its conflict of law provisions.
  </p>
  <p i18n="@@governingLawWaiver">
    Our failure to enforce any right or provision of these Terms will not be
    considered a waiver of those rights. If any provision of these Terms is held
    to be invalid or unenforceable by a court, the remaining provisions of these
    Terms will remain in effect. These Terms constitute the entire agreement
    between us regarding our Service, and supersede and replace any prior
    agreements we might have between us regarding the Service.
  </p>

  <b i18n="@@changes">Changes</b>
  <p i18n="@@changesText">
    We reserve the right, at our sole discretion, to modify or replace these
    Terms at any time. If a revision is material we will try to provide at least
    30 days notice prior to any new terms taking effect. What constitutes a
    material change will be determined at our sole discretion.
  </p>
  <p i18n="@@changesAgreement">
    By continuing to access or use our Service after those revisions become
    effective, you agree to be bound by the revised terms. If you do not agree
    to the new terms, please stop using the Service.
  </p>

  <b i18n="@@contactUs">Contact Us</b>
  <p i18n="@@contactUsText">
    If you have any questions about these Terms, please contact us
  </p>
</div>
